import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SkillsOrCerts from './SkillsOrCerts';

export default class SkillsAndCertifications extends Component {
  static propTypes = {
    addJob: PropTypes.object,
    skillsByJobList: PropTypes.object,
    skillsSearch: PropTypes.func,
    jobCertifications: PropTypes.object,
    certificationsSearch: PropTypes.func,
    saveJob: PropTypes.func,
    updatePayReport: PropTypes.func,
    saveJobAndUpdatePay: PropTypes.func,
    returnSkillCertItems: PropTypes.func,
    display: PropTypes.bool,
    disabled: PropTypes.bool,
    quickUpdateJobDetailsAndPay: PropTypes.func,
    isMP: PropTypes.bool
  };

  render() {
    const { display, isMP, disabled } = this.props;
    if (display && display !== true) {
      return;
    }

    // Props Validation
    let SkillNameList = [];
    let Skills = [];
    let allSkills = [];
    let possibleSkills = [];
    let skillsSearchItems = [];
    if (this.props.addJob && this.props.addJob.jobDetails) {
      if (this.props.addJob.jobDetails.SkillNameList) {
        SkillNameList = this.props.addJob.jobDetails.SkillNameList;
      }
      if (this.props.addJob.jobDetails.Skills) {
        Skills = this.props.addJob.jobDetails.Skills;
      }
    }
    if (this.props.skillsByJobList && this.props.skillsByJobList.allSkills) {
      allSkills = this.props.skillsByJobList.allSkills;
      possibleSkills = this.props.skillsByJobList.allSkills?.map?.(skills => skills.answer) || [];
    }
    if (this.props.skillsByJobList && this.props.skillsByJobList.skillsSearchItems) {
      skillsSearchItems = this.props.skillsByJobList.skillsSearchItems;
    }

    let CertNameList = [];
    let Certifications = [];
    let allCerts = [];
    let possibleCertifications = [];
    let certsSearchItems = [];
    if (this.props.addJob && this.props.addJob.jobDetails) {
      if (this.props.addJob.jobDetails.CertNameList) {
        CertNameList = this.props.addJob.jobDetails.CertNameList;
      }
      if (this.props.addJob.jobDetails.Certifications) {
        Certifications = this.props.addJob.jobDetails.Certifications;
      }
    }
    if (this.props.jobCertifications && this.props.jobCertifications.allCerts) {
      allCerts = this.props.jobCertifications.allCerts;
      possibleCertifications = this.props.jobCertifications.allCerts?.map?.(certs => certs.answer) || [];
    }
    if (this.props.jobCertifications && this.props.jobCertifications.certsSearchItems) {
      certsSearchItems = this.props.jobCertifications.certsSearchItems;
    }

    return (
      <div className="row add-job__skillsAndCertifications">
        {!isMP && (
          <h3 className="add-job__all-headers">
            <i className="add-job__experience-heading-icon icon-star" />
            Skills and Certifications
          </h3>
        )}

        <SkillsOrCerts
          className="add-job__skillsOrCerts"
          possibleItems={possibleSkills}
          headerText={'Skills/Specialties'}
          title={'Choose the most important skills/specialties for this job'}
          searchPlaceholderText={'Search for Skills to add to this job'}
          selectedItemsNameList={SkillNameList}
          selectedItemsList={Skills}
          orgJobTitle={this.props.addJob.orgJobTitle}
          jobCode={this.props.addJob.jobCode}
          workLocationExact={this.props.addJob.workLocationExact}
          orgJobId={this.props.addJob.orgJobId}
          allAvailableItemsListByJob={allSkills}
          itemsSearch={this.props.skillsSearch}
          saveJob={this.props.saveJob}
          saveJobAndUpdatePay={this.props.saveJobAndUpdatePay}
          quickUpdateJobDetailsAndPay={this.props.quickUpdateJobDetailsAndPay}
          returnSkillCertItems={this.props.returnSkillCertItems}
          searchItems={skillsSearchItems}
          jobEditSection="skills"
          disabled={disabled}
          isMP={this.props.isMP}
        />
        <SkillsOrCerts
          className="add-job__skillsOrCerts"
          possibleItems={possibleCertifications}
          headerText={'Certifications/Licenses'}
          title={'Choose the most important certifications/licenses for this job'}
          searchPlaceholderText={'Search for Certifications to add to this job'}
          selectedItemsNameList={CertNameList}
          selectedItemsList={Certifications}
          orgJobTitle={this.props.addJob.orgJobTitle}
          jobCode={this.props.addJob.jobCode}
          workLocationExact={this.props.addJob.workLocationExact}
          orgJobId={this.props.addJob.orgJobId}
          allAvailableItemsListByJob={allCerts}
          itemsSearch={this.props.certificationsSearch}
          saveJob={this.props.saveJob}
          saveJobAndUpdatePay={this.props.saveJobAndUpdatePay}
          quickUpdateJobDetailsAndPay={this.props.quickUpdateJobDetailsAndPay}
          returnSkillCertItems={this.props.returnSkillCertItems}
          searchItems={certsSearchItems}
          jobEditSection="certs"
          disabled={disabled}
          isMP={this.props.isMP}
        />
      </div>
    );
  }
}
